// api/contacts.js
import api from '@/lib/api';

// Organizations
export async function fetchOrganizationById(orgId) {
  const { data } = await api.get(`/api/contacts/organizations/${orgId}/`);
  return data;
}
export async function deleteOrganization(orgId) {
  await api.delete(`/api/contacts/organizations/${orgId}/`);
}
export async function createOrganization(organizationData) {
  const { data } = await api.post(`/api/contacts/organizations/`, organizationData);
  return data;
}

// Contacts
export async function addContact(orgId, contact) {
  const { data } = await api.post(`/api/contacts/organizations/${orgId}/contacts/`, contact);
  return data;
}
export async function deleteContact(contactId) {
  await api.delete(`/api/contacts/contacts/${contactId}/`);
}
export async function updateContact(contactId, payload) {
  const { data } = await api.put(`/api/contacts/contacts/${contactId}/`, payload);
  return data;
}


export async function fetchOrganizations() {
  const { data } = await api.get(`/api/contacts/organizations/?include_contacts=1`);
  return data;
}